import yup from '@/libs/yup';

const TITLE_MAX_LENGTH = 60;

export default yup.object({
    title: yup
        .string()
        .trim()
        .max(TITLE_MAX_LENGTH, 'Title must be less than 60 characters.'),
    name: yup.string().personaName().required('Name is a required field'),
    description: yup.string()
});
